import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DynamicInput } from "../DynamicInput";
import api from '../../services/api';
import IntlCurrencyInput from "react-intl-currency-input"
import { StldInput } from '../../styled-components/StyledInput.style';
import { DynamicSelect } from "../DynamicSelect";

const currencyConfig = {
    locale: "pt-BR",
    formats: {
        number: {
            BRL: {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
};

export const ModalCicloPme = ({ isOpen, onAfterOpen, onRequestClose, onUpdateCiclos, loadPage, tiposCiclosList }) => {
    const [isLoading, setisLoading] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndtDate] = useState(null);
    const [apuracaoStartDate, setApuracaoStartDate] = useState(null);
    const [apuracaoEndDate, setApuracaoEndtDate] = useState(null);
    const [pagamentoStartDate, setPagamentoStartDate] = useState(null);
    const [pagamentoEndDate, setPagamentoEndtDate] = useState(null);
    const [dataLimite, setDataLimite] = useState(null);
    const [nomeCiclo, setNomeCiclo] = useState(null);    
    const [descricaoCiclo, setDescricao] = useState(null);
    const [tipoCiclo, setTipoCiclo] = useState('');
    const [idTipoCiclo, setIdTipoCiclo] = useState(null);
    const [percentualTolerancia, setPercentualTolerancia] = useState(null);

    useEffect(() => {
        const asyncFn = async () => {
            if (tipoCiclo) {
                setTipoCiclo(tipoCiclo);
            }
        }
        asyncFn();

    }, [isOpen, tipoCiclo]);

    const style = {
        content: {
            top: '45%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: 'calc(0vh - 250px)',
            maxHeight: 'calc(100vh - 250px)',
        },
        overlay: {
            zIndex: 9999
        }
    };

    const getNomeCiclo = async (currentValue) => {
        setNomeCiclo(currentValue);
    }

    const getPercentualTolerancia = async (currentValue, value, pageSize) => {
        setPercentualTolerancia(currentValue);
    }

    const handleLimiteChange = (date) => {
        setDataLimite(date);
    }

    //Medição
    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    //Apuracao
    const handleApuracaoStartDateChange = (date) => {
        setApuracaoStartDate(date);
    }

    const handleApuracaoEndDateChange = (date) => {
        setApuracaoEndtDate(date);
    }

    //Pagamento
    const handlePagamentoStartDateChange = (date) => {
        setPagamentoStartDate(date);
    }

    const handlePagamentoEndDateChange = (date) => {
        setPagamentoEndtDate(date);
    }

    const handleDescricaoChange = (descricao) => {
        setDescricao(descricao);
    }

    const getCicloTipo = (currentValue, value) => {
        if (value === null || value === "") {
            setTipoCiclo(null);
            setIdTipoCiclo(null);
            return;
        }

        setTipoCiclo(currentValue.label);
        setIdTipoCiclo(currentValue.id);
    }

    const registrationSuccess = (text = "Configuração de desconto realizado com sucesso!") => {
        Swal.fire({
            title: "Sucesso",
            text: text,
            icon: "success",
            timer: 2500,
            showConfirmButton: false,
        });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const saveCiclo = async () => {
        let campos = [];
        
        if (!startDate) campos.push("Data inicial");
        if (!endDate) campos.push("Data final");
        if (!nomeCiclo) campos.push("Nome do Ciclo");

        if (campos.length > 0) {
            const camposFaltantes = campos.join(', ');
            registrationFailure(`Verifique os campos obrigatórios: ${camposFaltantes}`);
            return;
        }

        var payload = {
            nome: nomeCiclo,
            DataInicio: startDate,
            DataFim: endDate,
            DataInicioApuracao: apuracaoStartDate,
            DataFimApuracao: apuracaoEndDate,
            DataInicioPagamento: pagamentoStartDate,
            DataFimPagamento: pagamentoEndDate,       
            percentualTolerancia: percentualTolerancia == null ? 0 : percentualTolerancia,
            descricao: descricaoCiclo            
        };
        try {
            Swal.fire({
                title: "Sucesso",
                text: "Cadastro realizado com sucesso",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });
    
            setNomeCiclo("");
            setStartDate(null);
            setEndtDate(null);
            setApuracaoStartDate(null);
            setApuracaoEndtDate(null);
            setPagamentoStartDate(null);
            setPagamentoEndtDate(null);
            setPercentualTolerancia(null);
            setDescricao("");
    
            const updatedCiclos = await api.put('PmeCiclo/salvar', payload);
            onUpdateCiclos(updatedCiclos.data.data);
            onRequestClose();
        } catch (error) {
            registrationFailure("Erro ao salvar ciclo. Tente novamente.");
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="PME - Ciclo"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalCicloAdd>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <Flex>
                        <Flex.Item className="modal-width">
                            <div className="position-relative form-group">
                                <p className="modal-title">Adicionar Ciclo de Pagamento</p>
                            </div>
                        </Flex.Item>
                    </Flex>
                    {isLoading ? (
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            </div>
                        </div>
                    ) : (
                        <div>
                                <div className='row justify-align-content-around mt-3'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <DynamicInput placeholder={''} label={'Nome do Ciclo de Pagamento*'} name={'nomeCiclo'} paramMethod={getNomeCiclo} />
                                    </div>                                    
                                    {/* <div className="col-sm-12 col-md-5 col-lg-5 col-xxl-5">
                                        <StldInput>
                                            <DynamicSelect
                                                placeholder={''}
                                                valuetext={tipoCiclo}
                                                label={'Selecione o Tipo'}
                                                name={'tipoCiclo'}
                                                options={tiposCiclosList}
                                                keyValue={'id'}
                                                keyLabel={'label'}
                                                clearOption={true}
                                                paramMethod={getCicloTipo} />
                                        </StldInput>
                                    </div> */}
                                </div>
                                {/* MEDICAO */}
                                <div className='row justify-align-content-around mt-3'>
                                    <h6 className="mb-0">Medição</h6>
                                    <div className="position-relative col-sm-12 col-md-12 col-lg-12">
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={startDate}
                                                onChange={handleStartDateChange}
                                                placeholderText={'Data inicial medição'}
                                            />
                                        </div>
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pr-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={endDate}
                                                onChange={handleEndDateChange}
                                                placeholderText={'Data final medição'}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-sm-12 col-md-5 col-lg-5 col-xxl-5">
                                        <div className="position-relative form-group  col-md-12 col-lg-12 px-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={dataLimite}
                                                onChange={handleLimiteChange}
                                                placeholderText={'Data Limite'}
                                            />
                                        </div>
                                    </div> */}
                                </div>
                                {/* APURAÇÃO */}                                
                                <div className='row justify-align-content-around'>
                                    <h6 className="mb-0">Apuração</h6>
                                    <div className="position-relative col-sm-12 col-md-12 col-lg-12">
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={apuracaoStartDate}
                                                onChange={handleApuracaoStartDateChange}
                                                placeholderText={'Data inicial apuração'}
                                            />
                                        </div>
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pr-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={apuracaoEndDate}
                                                onChange={handleApuracaoEndDateChange}
                                                placeholderText={'Data final apuração'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* PAGAMENTO */}                                
                                <div className='row justify-align-content-around'>
                                    <h6 className="mb-0">Pagamento</h6>
                                    <div className="position-relative col-sm-12 col-md-12 col-lg-12">
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={pagamentoStartDate}
                                                onChange={handlePagamentoStartDateChange}
                                                placeholderText={'Data inicial pagamento'}
                                            />
                                        </div>
                                        <div className="position-relative form-group  col-md-6 col-lg-6 pr-0" style={{ float: 'left' }}>
                                            <DatePicker
                                                dateFormat="dd/MM/yyyy"
                                                locale="pt-BR"
                                                className="input-form"
                                                selected={pagamentoEndDate}
                                                onChange={handlePagamentoEndDateChange}
                                                placeholderText={'Data final pagamento'}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='row justify-align-content-around'>
                                    <div className="col-sm-12 col-md-5 col-lg-6 col-xxl-6">
                                        <StldInput>
                                            <label className="focused">% Percentual de Tolerancia</label>
                                            <IntlCurrencyInput
                                                currency="BRL"
                                                config={currencyConfig}
                                                defaultValue={percentualTolerancia}
                                                onChange={(_event, value, _maskedValue) => getPercentualTolerancia(value)}
                                                disabled={false} />
                                        </StldInput>
                                    </div>
                                </div>
                                <div className='row justify-align-content-around mt-3'>
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                                        <textarea
                                            rows="3"
                                            className="input-form-list"
                                            style={{ width: '100%' }}
                                            name="Mensagem"
                                            placeholder="Mensagem"
                                            key={descricaoCiclo}
                                            onBlur={(event) => handleDescricaoChange(event.target.value)} />
                                    </div>
                                </div>
                                <div className='d-flex justify-content-center mt-5'>
                                    <div className="col-sm-3 col-md-3 col-lg-3">
                                        <button type="button" className='default-button-red-small' onClick={() => saveCiclo()}>Salvar Ciclo</button>
                                    </div>
                                </div>
                        </div>
                    )}
                </StyledForm>
            </StyledModalCicloAdd>
        </Modal>
    );
};